import RequestAbstract from "./RequestAbstract";
import helper from "actions/helper";

export default class DoctorsScheduleShort extends RequestAbstract {
    get link() {
        return this.links.doctorSchedulesShort;
    }

    async getAllByClinic(clinicId) {
        const yearAgo = new Date(new Date().setFullYear(new Date().getFullYear() - 3));
        return this.getAllFiltered([
            [
                { field: "domainId", op: "=", value: clinicId },
                { field: "doctorId", op: ">", value: 0 },
                { field: "beginDate", op: ">", value: helper.date.toStr(yearAgo) },
            ]
        ], [{
            "field": "beginDate",
            "direction": "ASC"
        }]);
    }
}
